// Logger utility - disables console.logs in production for better performance
const isDevelopment = process.env.NODE_ENV === 'development';

export const logger = {
  // Only log in development
  log: (...args) => {
    if (isDevelopment) {
      console.log(...args);
    }
  },
  
  // Always log errors (important for debugging)
  error: (...args) => {
    console.error(...args);
  },
  
  // Only warn in development
  warn: (...args) => {
    if (isDevelopment) {
      console.warn(...args);
    }
  },
  
  // Only log info in development
  info: (...args) => {
    if (isDevelopment) {
      console.info(...args);
    }
  },
  
  // Debug logs (only in development)
  debug: (...args) => {
    if (isDevelopment) {
      console.debug(...args);
    }
  }
};

export default logger;

